import { createMainResourceREST, mergeSummaryBodyField } from '../resource';
import {
  CREmailBody,
  CREmailBodyAPI,
  CREmailKey,
  CREmailSummary,
  CREmailSummaryAPI,
  EmailsActions,
  EmailsState,
} from './types';

type AnyEmail = CREmailKey | CREmailSummary | CREmailBody | undefined;

function sameKeyEmail(a: AnyEmail, b: AnyEmail): boolean {
  return a?.emailId === b?.emailId;
}

function getEndpointEmail(key: AnyEmail): string {
  return key ? `/emails/${key.emailId}/` : '/emails/';
}

const getEndpointEmailAttachments = (
  emailId: number,
  attachmentNum?: number,
) => {
  let result = `${getEndpointEmail({ emailId })}attachments/`;
  if (attachmentNum) {
    result += attachmentNum + '/';
  }

  return result;
};

function parseEmailSummary(emailSummary: CREmailSummaryAPI): CREmailSummary {
  return emailSummary;
}

function parseEmailBody(emailDetail: CREmailBodyAPI): CREmailBody {
  return emailDetail;
}

const emailsStateSelector = (state: any): EmailsState => state.emails;

const emailsKeySelector = ({
  emailId,
}: CREmailBody | CREmailSummary): CREmailKey => ({ emailId });

function mergeEmailBody(lastBody: CREmailBody, currentBody: CREmailBody) {
  return currentBody;
}

function combineSummaryBodyEmail(
  summary?: CREmailSummary,
  body?: CREmailBody,
): CREmailSummary {
  const merge = mergeSummaryBodyField(summary, body);

  return {
    emailId: merge('emailId'),
    rowKey: merge('rowKey'),
  };
}

const { actions, reducer, watches } = createMainResourceREST(
  'emails',
  getEndpointEmail,
  emailsStateSelector,
  sameKeyEmail,
  parseEmailBody,
  parseEmailSummary,
  mergeEmailBody,
  combineSummaryBodyEmail,
);

const emailsActions: EmailsActions = actions;
export * from './types';
export {
  emailsActions,
  reducer as emailsReducer,
  watches as emailsWatches,
  emailsStateSelector,
  emailsKeySelector,
  getEndpointEmail,
  getEndpointEmailAttachments,
};
